import { useControl } from '../../../components/ControlLayout';
import { downloadCSV } from '../../../../../traits/api/controls/useDownloadCSV';

export const useDownloadCSV = () => {
  const control = useControl();
  const download = downloadCSV(control.data.workRegister.workRegisterId);

  return { download: download.downloadCSV };
};
